export const UPDATE_CLAIM_THRESHOLD = "UPDATE_CLAIM_THRESHOLD";
export const UPDATE_DELTA_CLAIM_THRESHOLD = "UPDATE_DELTA_CLAIM_THRESHOLD";
export const DOWNLOAD_ORIGINAL_CLAIMS_DATA_STARTED =
  "DOWNLOAD_ORIGINAL_CLAIMS_DATA_STARTED";
export const DOWNLOAD_ORIGINAL_CLAIMS_DATA_RETURNED =
  "DOWNLOAD_ORIGINAL_CLAIMS_DATA_RETURNED";
export const DOWNLOAD_ORIGINAL_CLAIMS_DATA_FAILED =
  "DOWNLOAD_ORIGINAL_CLAIMS_DATA_FAILED";
export const UPDATE_CLAIMS_NOTE = "UPDATE_CLAIMS_NOTE";
export const MANUAL_CREATE_MERGE_ENTRY = "MANUAL_CREATE_MERGE_ENTRY";
export const MANUAL_UPDATE_LOSS_YEAR = "MANUAL_UPDATE_LOSS_YEAR";
export const MANUAL_UPDATE_COVERAGE = "MANUAL_UPDATE_COVERAGE";
export const MANUAL_UPDATE_LOSS = "MANUAL_UPDATE_LOSS";
export const MANUAL_UPDATE_DESCRIPTION = "MANUAL_UPDATE_DESCRIPTION";
export const MANUAL_UPDATE_CLAIMANT = "MANUAL_UPDATE_CLAIMANT";
export const MANUAL_UPDATE_OPEN_CLOSED = "MANUAL_UPDATE_OPEN_CLOSED";
export const MANUAL_UPDATE_DATE_CLOSED = "MANUAL_UPDATE_DATE_CLOSED";
export const DELETE_MANUAL_CLAIMS = "DELETE_MANUAL_CLAIMS";
export const OVERIDE_CLAIM_VALUE = "OVERIDE_CLAIM_VALUE";
export const OVERRIDE_REPORTED_LOSS_CLAIM_VALUE =
  "OVERRIDE_REPORTED_LOSS_CLAIM_VALUE";
export const SET_CLAIM_OPEN_CLOSED_OVERRIDE = "SET_CLAIM_OPEN_CLOSED_OVERRIDE";
export const REMOVE_CLAIM_OPEN_CLOSED_OVERRIDE =
  "REMOVE_CLAIM_OPEN_CLOSED_OVERRIDE";
export const TOGGLE_CLAIM_EXCLUSION = "TOGGLE_CLAIM_EXCLUSION";
export const CLAIMS_TABLE_ADD_LOSS_YEAR = "CLAIMS_TABLE_ADD_LOSS_YEAR";
export const CLAIMS_TABLE_REMOVE_LOSS_YEAR = "CLAIMS_TABLE_REMOVE_LOSS_YEAR";
export const CLAIMS_FILE_CHECKED = "CLAIMS_FILE_CHECKED";
export const HIDE_CLAIMS_FILE = "HIDE_CLAIMS_FILE";
export const UPDATE_CLAIMS_FILTER = "UPDATE_CLAIMS_FILTER";
export const CLEAR_CLAIMS_FILTER = "CLEAR_CLAIMS_FILTER";
export const USE_FILTER_AS_BASE_LAYER = "USE_FILTER_AS_BASE_LAYER";
export const UPDATE_CLAIMS_ZOOM = "UPDATE_CLAIMS_ZOOM";
export const CLEAR_CHART_ZOOM = "CLEAR_CHART_ZOOM";
export const SET_INFLATION_MODEL = "SET_INFLATION_MODEL";
export const UPDATE_SELF_INSURED_RETENTION = "UPDATE_SELF_INSURED_RETENTION";
export const DELETE_SELF_INSURED_RETENTION = "DELETE_SELF_INSURED_RETENTION";
export const SET_SELF_INSURED_RETENTIONS = "SET_SELF_INSURED_RETENTIONS";
export const SHOW_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY =
  "SHOW_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY";
export const HIDE_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY =
  "HIDE_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY";
export const CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOADED =
  "CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOADED";
export const START_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOAD =
  "START_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOAD";
export const CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOAD_FAILED =
  "CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOAD_FAILED";
export const SET_V2_CLAIMS_KEY = "SET_V2_CLAIMS_KEY";
export const UPDATE_AGGREGATED_CLAIMS = "UPDATE_AGGREGATED_CLAIMS";
export const UPDATE_AI_CLAIMS_MATCHES = "UPDATE_AI_CLAIMS_MATCHES";
export const UPDATE_AI_MATCHING_DATA = "UPDATE_AI_MATCHING_DATA";
export const UPDATE_MANUAL_CLAIMS_MATCHES = "UPDATE_MANUAL_CLAIMS_MATCHES";
export const SET_DUPLICATE_GROUPS = "SET_DUPLICATE_GROUPS";
export const SET_IGNORED_DUPLICATES = "SET_IGNORED_DUPLICATES";
export const UPDATE_ACCEPTED_DUPLICATES = "UPDATE_ACCEPTED_DUPLICATES";
export const UPDATE_CLAIMS_FIELDS = "UPDATE_CLAIMS_FIELDS";
